import React from 'react';

import i18n from 'util/i18n';

import { getYearsString } from 'helpers/text';

import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { HistoryEmploymentItemModel } from 'forms/sections/history/employment/types';
import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import BranchCollection from 'components/Form/BranchCollection';
import { FieldModel } from 'forms/shared/types';
import Comments from 'components/Form/Comments';
import ReprimandItem from './ReprimandItem';

type ReprimandType = HistoryEmploymentItemModel['Reprimand']

interface Props extends ValidationElementProps, ReprimandType {
  onUpdate?: CommonOnUpdate
  recordYears?: number
  onError?: CommonOnError
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  ReprimandAnswerComments?: FieldModel
  ReprimandComments?: FieldModel
}

export default class Reprimand extends ValidationElement<Props> {
  updateReasons = (values: ReprimandType) => {
    this.props.onUpdate({
      ...values,
    });
  };

  branchComment = () => (
    <Comments
      title={i18n.t(`history.employment.default.reprimand.ReprimandAnswerComments`)}
      name="ReprimandAnswerComments"
      attribute="ReprimandAnswerComments"
      className="optional-comments"
      {...this.props.ReprimandAnswerComments}
      onUpdate={this.props.updateReprimandAnswerComments}
      onError={this.props.onError}
      required={false}
    />
  );

  render() {
    const { recordYears } = this.props;
    const recordYearsString = getYearsString(recordYears);

    return (
      <>
        <BranchCollection
          // attribute={setAttribute(this.props.attribute, 'branch.value')}
          label={i18n.t('history.employment.default.reprimand.label', {
            years: recordYears,
            yearsString: recordYearsString,
          })}
          appendLabel={i18n.t('history.employment.default.reprimand.append')}
          help="history.employment.default.reprimand.help"
          {...this.props}
          className="reprimand-branch"
          onUpdate={this.updateReasons}
          onError={this.props.onError}
          required={this.props.required}
          scrollIntoView={this.props.scrollIntoView}
          branchComment={this.branchComment}
        >
          <ReprimandItem
            attribute={this.props.attribute}
            name="Item"
            bind
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            Dates={this.props.Dates}
          />
        </BranchCollection>
        {this.props.items?.[0]?.Item?.Has?.value === 'Yes'
          && (
            <Comments
              title={i18n.t(`history.employment.default.reprimand.ReprimandComments`)}
              name="ReprimandComments"
              attribute="ReprimandComments"
              className="optional-comments"
              {...this.props.ReprimandComments}
              onUpdate={this.props.updateReprimandComments}
              onError={this.props.onError}
              required={false}
            />
          )}
      </>
    );
  }
}

Reprimand.defaultProps = {
  Reasons: { items: [] },
  Dates: {},
  ReprimandAnswerComments: {},
  updateReprimandComments: () => { },
  updateReprimandAnswerComments: () => { },
  onUpdate: () => { },
  onError: (value, arr) => arr,
};
